import cryptoUtils from '@/utils/cryptoUtils';

export default class StorageClient {
    storage;

    constructor(storage) {
        this.storage = storage;
    }

    getItem = (key) => JSON.parse(this.storage.getItem(key));

    setItem = (key, value) => this.storage.setItem(key, JSON.stringify(value));

    removeItem = (key) => this.storage.removeItem(key);

    getEncodedItem = (key) => {
        try {
            const item = this.storage.getItem(key);
            const encodedItem = cryptoUtils.atob(item);

            return JSON.parse(encodedItem);
        } catch (e) {
            return null;
        }
    };

    setDecodedItem = (key, value) => this.storage.setItem(key, cryptoUtils.btoa(JSON.stringify(value)));
}
